<template>
  <div class="mb-2 flex justify-center">
    <LinkToCreateEdit :to="{ name: 'customerCreate' }">
      Add Customer
    </LinkToCreateEdit>
  </div>

  <div class="mb-4">
    <SearchInput v-model="searchRaw" />
  </div>

  <BaseInnerLoading v-if="isLoading" />

  <ul
    v-else-if="data"
    class="divide-y divide-background-fg/8"
  >
    <template
      v-for="customer in customers"
      :key="customer.id"
    >
      <li>
        <RouterLink
          :to="{
            name: 'customerDetail',
            params: {
              customerId: customer.id,
            },
          }"
        >
          <CustomerInfoCard :customer="customer" />
        </RouterLink>
      </li>
    </template>
  </ul>

  <div class="mt-4 flex justify-center">
    <BasePagination
      v-model="page"
      :page-count="pageCount"
    />
  </div>
</template>

<script setup lang="ts">
const searchRaw = ref<string>("")
const search = refDebounced(searchRaw, 750)

const { pagination, page, pageCount, resetPagination } =
  useDRFPagination({
    limit: 10,
    count: computed(() => data.value?.count || 0),
  })

watch(
  () => [search],
  () => resetPagination(),
  { deep: true, immediate: true }
)

const query = reactiveComputed(() => ({
  ...pagination.value,
  search: search.value?.trim(),
}))

const { data, isLoading } = useCustomers(query)

const customers = computed(() => data.value?.results ?? [])
</script>
